export default {
      id: "pay_secure-usage",
      viewBox: "0 0 74 27",
      url: __webpack_public_path__ + "sprite.svg#pay_secure",
      toString: function () {
        return this.url;
      }
    }